<template>

  <div class="login-wrapper df fdc jcfs aic f1 w100p" v-bind:class="{
    'getting-pro': $route.query.pro == 'getpro'
  }">

    <!-- LOGIN INPUTS -->

    <!-- SPLASH -->
    <div class="login-splash df fdc aifs w100p">
      <div class="login-big-text df fdc w100p" v-if="$route.query.auth == 'pro'">
        <div class="df splash-hero f1 df aic fdc w100p" v-if="$route.query.pro == 'getpro'">
          <div class="df fdr jcsb aic f2 w100p mw870">

            <div class="checkout df fdc">
              <div class="df">
                <p class="checkout-price">$24.99</p>
                <span class="df fdc checkout-price-next">
                  <p>Per month</p>
                  <p>Standard plan</p>
                </span>
              </div>
              <hr class="checkout-line">
                <div class="product-detail f1 df fdc mb20">
                  <h4>Email</h4>
                    <input class="checkout-input" placeholder="Your Email" v-model="displayName" type="" name="">
                </div>
                <!-- <div class="df w100p product-detail-outer">
                  <div class="product-detail f1">
                    <h4>Current Password</h4>
                    <input placeholder="Password" v-model="currentPassword" type="" name="">
                  </div>
                  <div class="product-detail f1">
                  </div>
                </div> -->
                <div class="df w100p product-detail-outer">
                  <div class="product-detail f1 _s2_1">
                    <h4>Password</h4>
                    <input class="checkout-input" placeholder="Password" v-model="newPassword" type="" name="">
                  </div>
                  <div class="product-detail f1 _s2_2">
                    <h4>Confirm Password</h4>
                    <input class="checkout-input" placeholder="Confirm Password" v-model="newPasswordConfirm" type="" name="">
                  </div>
                </div>
              <hr class="checkout-line">
              <div class="df w100p product-detail-outer">
                <div class="product-detail f1 payment-methods">
                  <h4 class="_s1">Payment Method</h4>
                  <span class="df">
                    <span class="df one-payment-method check-fulfillment aic">
                      <input v-model="checkOutOption"
                      type="checkbox"
                      class="check-fulfillment-box"
                      name=""
                      id="checkoutPaymentMethod">
                      <label for="checkoutPaymentMethod"></label>
                      <img src="../../static/images/icon-card.svg">
                      <p>
                        Credit Card
                      </p>
                    </span>
                    <span class="df one-payment-method check-fulfillment aic">
                      <input v-model="checkOutOptionB"
                      type="checkbox"
                      disabled="true" 
                      class="check-fulfillment-box"
                      name=""
                      id="checkoutPaymentMethod2">
                      <label for="checkoutPaymentMethod2"></label>
                      <img src="../../static/images/icon-paypal.svg">
                      <p>
                        PayPal
                      </p>
                    </span>
                  </span>
                  <!-- <input class="checkout-input" placeholder="Password" v-model="newPassword" type="" name=""> -->
                </div>
              </div>
              <!-- Payment method == CC, paypal coming soon -->
              <div class="card-error df" v-if="checkoutError">
                <span class="warning df aic jcc">
                  <img src="../../static/images/icon-warning.svg">
                </span>
                <span class="f1 df fdc jcc card-error-message">
                  <p>Double check your information</p>
                  <p>{{checkoutError.message || '-'}}</p>
                </span>
              </div>
              <input class="checkout-input"></input>
              <a class="button-1 w100p checkout-button" @click="getProPlan()">Pay $24.99</a>
              <p class="checkout-protection">This site is protected by reCAPTCHA. The Google Privacy Policy and Terms of Service apply.</p>
            </div>

            <div class="pricing-plans">
              
              <div class="pricing-plan">
                <div class="pricing-plan-header pricing-1">
                  <p class="pricing-plan-header-name">Pro</p>
                  <hr/>
                  <p class="pricing-plan-header-price">$24.99/month</p>
                  <p class="pricing-plan-header-subheading">Up to 10 Cuppings</p>
                </div>
                <!-- <div class="f1"></div> -->
                <div class="pricing-plan-box pricing-plan-single">
                  <span class="pricing-plan-two-liner">
                    <p>Up to 150 Cuppers</p>
                    <p>Per cupping</p>
                  </span>
                  <span class="pricing-plan-two-liner">
                    <p>5 Coffees</p>
                    <p>Per session</p>
                  </span>
                  <p>Host your own cuppings</p>
                  <p>Use the Cupwise library</p>
                  <p>Cupping statistics</p>
                  <p>Embeddable</p>
                  <!-- <div class="f1"></div> -->
                  <!-- <a class="button-1" @click="addQuery('pro', 'getpro')">Get Started</a> -->
                </div>  
              </div>
              

            </div>


          </div>
          <div class="df fdc jcc aic f3">
          </div>
        </div>
        <div class="df splash-hero f1 df fdc w100p" v-else>
          <div class="df fdc jcc f2 auth-message-wrapper w100p _m4">


            <h2 class="line-3">Become a pro member</h2>
            <p class="line-2"><span class="highlight">Sign up for free</span> today and taste coffee together online! Learn about your taste from and with like-minded coffee enthusiasts.</p>
            <!-- <a class="button-1 _button-1" @click="addQuery('auth', 'register')">Get Started</a> -->
          </div>
          <div class="df fdc jcc f2 w100p">

            <div class="pricing-plans">
              
              <div class="pricing-plan">
                <div class="pricing-plan-header pricing-1">
                  <p class="pricing-plan-header-name">Pro</p>
                  <hr/>
                  <p class="pricing-plan-header-price">$24.99/month</p>
                  <p class="pricing-plan-header-subheading">Up to 10 Cuppings</p>
                </div>
                <div class="f1"></div>
                <div class="pricing-plan-box">
                  <span class="pricing-plan-two-liner">
                    <p>Up to 150 Cuppers</p>
                    <p>Per cupping</p>
                  </span>
                  <span class="pricing-plan-two-liner">
                    <p>5 Coffees</p>
                    <p>Per session</p>
                  </span>
                  <p>Host your own cuppings</p>
                  <p>Use the Cupwise library</p>
                  <p>Cupping statistics</p>
                  <p>Embeddable</p>
                  <div class="f1"></div>
                  <!-- <a class="button-1" @click="addQuery('pro', 'getpro')">Get Started</a> -->
                  <a class="button-1" @click="goTo('/get/pro')">Get Started</a>
                </div>  
              </div>
              
              <div class="pricing-plan">
                <div class="pricing-plan-header pricing-2">
                  <p class="pricing-plan-header-name">Pro+</p>
                  <hr/>
                  <p class="pricing-plan-header-price">$99.99/month</p>
                  <p class="pricing-plan-header-subheading">Up to 50 Cuppings</p>
                </div>
                <div class="f1"></div>
                <div class="pricing-plan-box">
                  <span class="pricing-plan-two-liner">
                    <p>Up to 1000 Cuppers</p>
                    <p>Per cupping</p>
                  </span>
                  <span class="pricing-plan-two-liner">
                    <p>50 Coffees</p>
                    <p>Per session</p>
                  </span>
                  <p> + Create your own templates</p>
                  <p> + Advanced cupping statistics</p>
                  <p> + Self-brand customization</p>
                  <p> + Schedule cuppings and invite friends</p>
                  <p> + Advanced host tools</p>
                  <div class="f1"></div>
                  <a class="button-1 pricing-2" curp>Coming soon</a>
                </div>  
              </div>
              
              <div class="pricing-plan">
                <div class="pricing-plan-header pricing-3">
                  <p class="pricing-plan-header-name">Enterprise</p>
                  <hr/>
                  <p class="pricing-plan-header-price">Contact Us</p>
                  <p class="pricing-plan-header-subheading">51+ Cuppings</p>
                </div>
                <div class="f1"></div>
                <div class="pricing-plan-box">
                  <span class="pricing-plan-two-liner">
                    <p>Up to 1001+ Cuppers</p>
                    <p>Per cupping</p>
                  </span>
                  <span class="pricing-plan-two-liner">
                    <p>100 Coffees</p>
                    <p>Per session</p>
                  </span>
                  <p>+ Integration support</p>
                  <p>+ Brand customization</p>
                  <p>+ Enterprise Statistics</p>
                  <p>+ Much More</p>
                  <div class="f1"></div>
                  <a href="mailto:vbaranov@cup-wise.com" class="button-1 pricing-3 nodec">Contact Us</a>
                </div>  
              </div>

            </div>


          </div>
          <div class="df fdc jcc aic f3">
          </div>
        </div>
      </div>
      <div class="login-big-text df fdc w100p" v-else-if="$route.query.auth == 'about'">
        About
      </div>
      <div class="login-big-text df fdc w100p" v-else>
        <div class="df splash-hero f1 df fdc aifs">
          <div class="df fdc jcc f2 auth-message-wrapper">
            <h2 class="line-1">Taste coffee<br/>together anywhere</h2>
            <p class="line-2">Taste coffee together online. Learn about your taste from and with like-minded coffee enthusiasts.</p>
            <a v-if="$store.getters['AUTH.anonUser']" class="button-1 _button-1" @click="addQuery('auth', 'register')">Get Started</a>
            <a v-else class="button-1 _button-1" @click="goTo('/me')">Get Started</a>
            <!-- <p class="convert-line">Host <span class="highlighted-text">live cupping sessions</span></p>
            <p class="convert-line">Create <span class="no-word-break highlighted-text">shared tastings</span></p>
            <p class="convert-line"><span class="no-word-break highlighted-text">Engage</span> your customers</p> -->
            <!-- <div class="f1 df fdc jcc aic previews">
              <p>Previews</p>
            </div> -->
          </div>
          <div class="df fdc jcc aic f3">
          </div>
        </div>
        <hr class="full-line full-line-1 w100p"/>
        <div class="landing-section">
          <div class="landing-section-visual vis-1"></div>
          <div class="landing-section-text">
            <h3>Join realtime cupping sessions with discussion and video</h3>
            <p>CupWise helps bridge the gap between how roasters and consumers think and talk about coffee. Host and join live cupping events. Participate in blind cupping, live chat and video. See how groups scoring and descriptions compare to your expectations.</p>
          </div>
        </div>
        <div class="landing-section flip-landing-section">
          <div class="landing-section-text">
            <h3>Get breakthrough insights</h3>
            <p>CupWise provides the ability to analyze, discuss and rate coffee together in an interactive, fun manner. Unique data like polarization and score change over time gives you insights that you’ve never had before. Plus, because you can create your own scoring templates, you can get the exact feedback that you need!
            </p>
          </div>
          <div class="landing-section-visual vis-2"></div>
        </div>
        <div class="landing-section">
          <div class="landing-section-visual vis-3"></div>
          <div class="landing-section-text">
            <h3>Embedded scoring</h3>
            <p>Embed CupWise scoring directly into your website to get direct product feedback from customers. Use customizable scoring templates to quickly get the information that you need. Whether you host cupping events, sell coffee or are an enthusiast looking for great new coffee, we invite you to find out how to integrate CupWise into your strategy.
            </p>
          </div>
        </div>
        <div v-if="$store.getters['AUTH.anonUser']" class="full-width df jcc aic w100p">
          <div class="df aic jcsb w100p max">
            <h3>Sign up for a free account today</h3>
            <a class="button-4" @click="addQuery('auth', 'register')">
              Sign Up
            </a>
          </div>
        </div>
        <div v-else class="full-width df jcc aic w100p">
          <div class="df aic jcsb w100p max">
            <h3>Go to the dashboard to start</h3>
            <a class="button-4" @click="goTo('/me')">
              Go
            </a>
          </div>
        </div>
      </div>


      <div class="auth-background" v-if="($route.query.pro == 'get') || ($route.query.auth == 'login') || ($route.query.auth == 'register')" @click="closeMenus($route.query.pro == 'get')">
      </div>
      <div class="login-inputs auth-menu df fdc" v-if="($route.query.pro == 'get')">
        <img src="../../static/images/close-x.svg" @click="addQuery('pro', undefined)" class="close-menu">
        <h4 class="_m2 get-started">Be the first to get Pro!</h4>
        <p class="cupwise"><span>Sign Up to Cup</span>Wise</p>
        <p class="already-have-account-line auth-sub">Sign up to get notified when Cupwise is available.</p>
        <p v-if="emailSubmitted" class="thank-you"><span>Thank you!</span> We will e-mail you soon.</p>
        <p class="login-input-heading" v-if="!emailSubmitted">Email</p>
        <input v-model="email" placeholder="E-mail" type="text" name="" v-if="!emailSubmitted">
        <a class="_m1 button-1 _button-1" @click="submitEmail()" v-if="!emailSubmitted">Submit</a>
      </div>



      <div class="login-inputs auth-menu df fdc" v-if="($route.query.auth == 'register')">
        <img src="../../static/images/close-x.svg" @click="addQuery('auth', undefined)" class="close-menu">
        <h4 class="_m2 get-started">Get started as a cupper for free!</h4>
        <p class="cupwise"><span>Sign Up to Cup</span>Wise</p>
        <p class="already-have-account-line auth-sub">Already a member? <a @click="addQuery('auth', 'login')">Log in.</a></p>
        <p class="login-input-heading">Email</p>
        <input v-model="email" placeholder="E-mail" type="text" name="">
        <p class="login-input-heading">Password</p>
        <input placeholder="Password" type="password" v-model="password" name="">
        <p class="login-input-heading">Repeat Password</p>
        <input placeholder="Repeat Password" type="password" v-model="password2" name="">
        <p v-if="error">{{error}}</p>
        <a class="_m1 button-1 _button-1" @click="register()">Register</a>
        <p class="_m3 get-started">Looking to host sessions? <a @click="addQuery('auth', 'pro')">Get a Pro Account!</a></p>
      </div>

      <div class="login-inputs auth-menu df fdc" v-if="($route.query.auth == 'login')">
        <img src="../../static/images/close-x.svg" @click="addQuery('auth', undefined)" class="close-menu">
        <h4 class="_m2 get-started">Log in to start cupping!</h4>
        <p class="cupwise"><span>Log In to Cup</span>Wise</p>
        <p class="already-have-account-line auth-sub">Don't have an account? <a @click="addQuery('auth', 'register')">Register here.</a></p>
        <p class="login-input-heading">Email</p>
        <input v-model="email" placeholder="E-mail" type="text" name="">
        <p class="login-input-heading">Password</p>
        <input v-model="password" placeholder="Password" type="password" name="">
        <div class="df w100p jcsb">
        </div>
        <p v-if="error">{{error}}</p>
        <a class="_m1 button-1 _button-1" @click="login()">Login</a>
      </div>

<!--       <div class="login-inputs df fdc" v-if="loginMode == 'password-recovery'">
        <h4>Password Recovery: Enter your email</h4>
        <input type="text" name="">
        <button>Recover Password</button>
      </div> -->
    </div>


  </div>
</template>

<script>

import router from '../router'

export default {
  name: 'Login',
  data () {
    return {
      checkOutOption: true,
      checkOutOptionB: false,
      checkoutError: '',
      showAuthMenu: false,
      loginMode: 'register',
      loading: false,
      email: '',
      password: '',
      password2: '',
      error: '',
      emailSubmitted: false,
      displayName: '',
      newPassword: '',
      newPasswordConfirm: '',
    }
  },
  props: [],
  components: {
  },
  methods: {
    goTo (path) {
      router.push(path)
      window.scrollTo(0,0)
    },
    getProPlan () {
      let email = this.email
      let password = this.password
      let password2 = this.password2

      this.$store.dispatch('AUTH.getProPlan', {
        email: this.email,
      }).then((res) => {
        console.log('res', res)
        if (res.message == 'ok') {
          // this.emailSubmitted = true
        }
        // this.error = ''
      }).catch((err) => {
        console.log('err', err)
        // this.error = err.message
      })
    },
    closeMenus (pro) {
      this.addQuery('auth', pro ? 'pro' : undefined)
      this.addQuery('pro', undefined)
    },
    addQuery (query, param) {
      this.$router.replace({
        query: Object.assign({}, this.$route.query, {
          [query]: param
        })
      })
      window.scrollTo(0,0)
    },
    login () {
      this.$store.dispatch('AUTH.login', {
        email: this.email,
        password: this.password,
      }).then((res) => {
        this.error = ''
      }).catch((err) => {
        this.error = err.message
      })
    },
    submitEmail () {
      this.$store.dispatch('AUTH.submitEmail', {
        email: this.email,
      }).then((res) => {
        console.log('res', res)
        if (res.message == 'ok') {
          this.emailSubmitted = true
        }
        // this.error = ''
      }).catch((err) => {
        console.log('err', err)
        // this.error = err.message
      })
    },
    register () {
      if (this.password == this.password2) {
        this.$store.dispatch('AUTH.register', {
          // name: this.name,
          anon: this.$store.getters['AUTH.anonUser'],
          email: this.email,
          password: this.password
        }).then((res) => {
        this.error = ''
        }).catch((err) => {
          this.error = err.message
        })
      } else {
        console.log('..')
        this.error = 'The passwords do not match'
      }
    },
    setLoginMode (loginMode) {
      this.loginMode = loginMode
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    console.log('* Landing page created')
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";

  ._m1 {
    margin-bottom: 8px;
    margin-top: 22px;
  }

  ._m2 {
    margin-bottom: 8px;
  }

  h1 {
    margin-bottom: 30px;
    font-size: 50px;
    max-width: 720px;

    & + p {
      font-size: 24px;
    }
  }

  .login-wrapper {
    /*background-color: #292929;*/
    padding: 30px 60px;
    padding-top: 30px;
    padding-top: 118px;
    padding-bottom: 300px;
    background-color: #fff;
  }
  .login-splash {
    width: 100%;
    max-width: 1200px;
    padding: 0;
    /*padding: 85px 90px;*/
    /*border: 1px solid $color-white;*/

    & > div {
      &:first-child {
        /*margin-right: 120px;*/
      }
    }

  }
  .splash-hero {
    height: 250px;
    /*margin-top: 20px;*/
  }
  .login-inputs {
    /*position: absolute;*/
    /*top: 0;*/
    /*right: 60px;*/
    padding-top: 20px;
    width: 200px;
    font-size: 12px;

    input {
      border: none;
      height: 40px;
      width: 100%;
      max-width: 390px;
      border-radius: 2px;
      background-color: #F3F3F5;
    }
  }
  .convert-line {
    margin-bottom: 4px;
    font-weight: 300;
    /*font-family: "Nexa";*/
    font-size: 28px;

    &:last-of-type {
      margin-bottom: 0;
    }

    span {
      /*font-family: "Nexa";*/
      font-weight: 600 !important;
    }
  }
  .already-have-account-line {
    margin-bottom: 6px;

    span {
      cursor: pointer;
      text-decoration: underline;
      color: #5469d4;
    }
  }
  .no-word-break {
    white-space: nowrap;
    /*white-space: none;*/
  }
  .convert-line {
    .highlighted-text {
      font-weight: 600 !important;
      span {
        font-weight: 600 !important;
      }
      color: #5469d4;
    }
  }
  .previews {
    /*margin-bottom: 20px;*/
  }

  .cupwise-logo {
    width: 110px;
  }

  .beta {
    /*margin-left: 20px;*/
  }

  .auth-background {
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    position: fixed;
    background-color: rgba(0,0,0,0.5);
  }

  .auth-menu {
    background-color: white;
    border-radius: 5px;
    z-index: 200;
    top: 100px;
    left: 50%;
    width: calc(100% - 90px);
    max-width: 690px;
    padding: 60px 90px;
    /*position: fixed;*/
    position: absolute;
    transform: translate(-50%, 0);
  }

  @media (max-height: 828px) {
    .auth-menu {
      top: 25px;
    }
  }

  @media (max-width: 750px) {
    .auth-menu {
      padding-left: 60px;
      padding-right: 60px;
    }
  }

  @media (max-width: 550px) {
    .auth-menu {
      padding: 40px;
      width: 100%;
      /*width: calc(100% - 50px);*/
      border-radius: 0;
      padding-left: 40px;
      padding-right: 40px;
      /*padding: 30px 40px;*/
    }
  }

  @media (max-width: 450px) {
    .auth-menu {
      padding-left: 20px;
      padding-right: 20px;
      /*padding: 20px 20px;*/
    }
  }

  .cupwise {
    color: #000000;
    font-family: Inter;
    font-size: 48px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 59px;

    span {
      font-weight: 700;
    }
  }

  .auth-sub {
    /*color: #27C8B3;*/
    font-family: Inter;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 20px;
    margin-top: 16px;
  }

  a {
    color: $color-primary;
    font-weight: bold;
  }

  .get-started {
    font-family: Inter;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 20px;
  }

  .login-input-heading {
    color: #49494C;
    font-family: Inter;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 17px;
    margin-bottom: 13px;
    margin-top: 22px;

    &:first-of-type {
      margin-top: 16px;
    }
  }

  ._button-1 {
    max-width: 163px;
  }

  .close-menu {
    position: absolute;
    top: 12px;
    right: 15px;
    cursor: pointer;
  }

  .line-1 {
    color: #000000;
    font-family: Inter;
    font-size: 48px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 59px;
  }

  .line-2 { 
    color: #000000;
    font-family: Inter;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 20px;
    margin-top: 12px;
    margin-bottom: 24px;

    .highlight {
      color: #27C8B3;
    }
  }

  .line-3 {
    color: #000000;
    font-family: Inter;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 39px;
    margin-bottom: 8px;
  }

  .auth-message-wrapper {
    width: 100%;
    max-width: 510px;
  }

  ._m3 {
    margin-top: 22px;
  }

  ._m4 {
    margin-bottom: 25px;
  }

  .nodec {
    text-decoration: none;
  }

  .thank-you {
    margin-top: 30px;
    font-size: 20px;
    span {
      color: $color-primary;
    }
  }

  .full-line {
    width: 100%;
    height: 1px;
    background-color: #979797;
  }

  .full-line-1 {
    margin-top: 165px;
    margin-bottom: 57px;
  }

  @media (max-width: 1000px) {
    .full-line-1 {
      margin-top: 80px;
    }
  }
  @media (max-width: 580px) {
    .full-line-1 {
      margin-top: 60px;
    }
  }


  .landing-section {
    display: flex;
    justify-content: space-between;
    margin-bottom: 57px;

    &-text {
      height: 100%;
      flex: 1;
      height: 547px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-left: 90px;
      margin-bottom: 20px;

      h3 {
        width: 100%;
        color: #000000;
        font-family: Inter;
        font-size: 32px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 39px;
        margin-bottom: 9px;
        text-align: left;
      }

      p { 
        color: #000000;
        font-family: Inter;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 20px;
        text-align: left;
      }
    }

    &-visual {
      width: 538px;
      height: 547px;
      /*border: 1px solid #27C8B3;*/
      border-radius: 10px;
      background-size: cover;
    }

    &:nth-of-type(odd) {
      .landing-section-text {
        margin-left: 0;
        margin-right: 90px;
      }
    }

    @media (max-width: 1160px) {
      .landing-section-visual {
        width: 392px;
        height: 400px;
      }
      .landing-section-text {
        height: 400px;
        h3 {
          font-size: 28px;
          line-height: 34px;
        }
      }
    }

    @media (max-width: 975px) {
      .landing-section-visual {
        width: 270px;
        height: 275px;
      }
      .landing-section-text {
        height: 270px;
        margin-left: 60px;
      }


      &:nth-of-type(odd) {
        .landing-section-text {
          margin-left: 0;
          margin-right: 60px;
        }
      }
    }

  }
  @media (max-width: 768px) {
    .landing-section {
      flex-direction: column;
      align-items: center;

      .landing-section-visual {
        width: 370px;
        height: 375px;
      }
      .landing-section-text {
        text-align: center;
        height: 270px;
        margin-left: 0px;
        margin-top: 30px;
      }

      &:nth-of-type(odd) {
        .landing-section-text {
          /*margin-left: 0;*/
          margin-right: 0px;
        }
      }
    }
    .flip-landing-section {
      flex-direction: column-reverse;
    }
  }
  @media (max-width: 480px) {
    .login-wrapper {
      padding-left: 30px;
      padding-right: 30px;
    }
    .landing-section {
      align-items: center;
      height: unset;

      .landing-section-visual {
        /*margin-top: 20px;*/
        width: 270px;
        height: 270px;
      }
    }
  }

  .full-width {
    width: 100%;
    height: 137px;
    background-color: $color-primary;
    position: absolute;
    bottom: 90px;
    left: 0;
  }

  @media (max-width: 768px) {
    .full-width {
      bottom: 200px;
    }
  }

  .max {
    max-width: 1200px;
    padding-left: 60px;
    padding-right: 60px;

    h3 {
      color: #FFFFFF;
      font-family: Inter;
      font-size: 32px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 39px;
    }
  }

  @media (max-width: 568px) {
    .full-width {
      height: 250px;
    }
    .max {
      padding-left: 30px;
      padding-right: 30px;
      h3 {
        text-align: center;
        font-size: 26px;
        margin-bottom: 20px;
      }
      flex-direction: column;
    }
  }

  .vis-1 {
    background-image: url('../../static/images/post-1-d.jpg');
    background-position: 25% center;
    background-size: fill;
  }
  .vis-2 {
    background-image: url('../../static/images/post-2-d.jpg');
  }
  .vis-3 {
    background-image: url('../../static/images/post-3-b.png');
  }

  .checkout {
    max-width: 420px;
    flex: 1;
    /*margin-right: 124px*/
  }

  .getting-pro {
    background-color: #f7f8f9;
  }

  .checkout-input {
    border-radius: 2px;
    background-color: white;
    border: none;
    font-family: Inter;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 15px;
  }

  .checkout-line {
    width: 100%;
    height: 1px;
    background-color: #979797;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .mw870 {
    max-width: 870px;
  }

  .payment-methods {
    margin-bottom: 26px;
  }


  .one-payment-method {
    img {
      height: 16px;
      margin-left: 5px;
      margin-right: 10px;
    }
    p {
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 17px;
    }

    &:first-child {
      margin-right: 90px;
    }
  }

  .checkout-protection {
    margin-top: 26px;
    color: #5C5C5C;
    font-family: Inter;
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 12px;
  }

  .checkout-button {
    margin-top: 26px;
  }

  .card-error {
    height: 70px;
    background-color: #FFF7D4;
    margin-bottom: 26px;

    .warning {
      width: 50px;
      height: 70px;
      background-color: #FFDA4B;
    }

    .card-error-message {
      padding-left: 15px;
      padding-right: 15px;

      p {
        color: #000000;
        font-family: Inter;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 15px;

        &:first-child {
          font-weight: 700;
        }
      }
    }

  }


  .check-fulfillment {
    margin-right: 15px;

    input {
      width: 20px;
    }
  }
.check-fulfillment {
  position: relative;
}

.check-fulfillment label {
  border-radius: 50%;
  cursor: pointer;
  left: 0;
  position: absolute;
  top: 0;
  height: 18px;
  width: 18px;
  border: 1px solid #5C5C5C;
  background-color: #F3F3F5;
}

.check-fulfillment label:after {
  content: " ";
  height: 10px;
  width: 10px;
  background-color: #27C8B3;
  left: 3px;
  border-radius: 50%;
  opacity: 0;
  position: absolute;
  top: 3px;
  /*transform: rotate(-45deg);*/
}

.check-fulfillment input[type="checkbox"] {
  visibility: hidden;
}

.check-fulfillment input[type="checkbox"]:checked + label {
  /*background-color: #66bb6a;*/
  /*border-color: #66bb6a;*/
}

.check-fulfillment input[type="checkbox"]:checked + label:after {
  opacity: 1;
}



  .check-fulfillment-box {
    display: flex;
    height: 20px;
    margin: 0;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  ._s1 {
    margin-top: 2px;
    margin-bottom: 20px !important;
  }

  .checkout-price {
    color: #27C8B3;
    font-family: Inter;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 29px;
    text-align: center;
  }

  .checkout-price-next {
    margin-left: 20px;
    p {
      color: #000000;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 17px;
    }
  }

  ._s2_1 {
    margin-right: 11px;
  }

  ._s2_2 {
    margin-left: 11px;
  }























</style>



// WEBPACK FOOTER //
// src/pages/GetPro.vue